import { oz } from '@weft/utils';
import { ApiDateSchema } from './api-date-schema';

export const PaymentInfoSchema = oz.object({
  transactionId: oz.string().min(1, 'Transaction ID is required'),
  date: ApiDateSchema,
  note: oz.string().optional(),
}).openapi('PaymentInfo');

export type PaymentInfo = oz.infer<typeof PaymentInfoSchema>;